const RASTER_TILES_SOURCE_ID = 'rasterTilesSource';

const source = {
  id: RASTER_TILES_SOURCE_ID,
  data: `cartodb-gcp-solutions-eng-team.telus_alberta.qk_2100_rsrp_z12_qk6`,
  type: 'bq',
};

export default source;
